import Button from "../utilities/button/Button";
import styles from "./ResetPasswordPage.module.css";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

function ResetPasswordPage() {
  const [seePasswordOne, setSeePasswordOne] = useState(false);
  const [seePasswordTwo, setSeePasswordTwo] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [overlapStatus, setOverlapStatus] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  function newPasswordHandler(e) {
    setNewPassword(e.target.value);
  }

  function confirmPasswordHandler(e) {
    setconfirmPassword(e.target.value);
  }

  function ClickHandlerOne() {
    setSeePasswordOne((val) => {
      return !val;
    });
  }

  function ClickHandlerTwo() {
    setSeePasswordTwo((val) => {
      return !val;
    });
  }

  async function submitHandler(e) {
    e.preventDefault();

    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/user/resetpassword?token=${searchParams.get(
          "token"
        )}`,
        {
          method: "POST",
          body: JSON.stringify({ newPassword }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (result.ok) {
        setOverlapStatus(true);
      }
    } catch (err) {
      console.log(err);
    }
  }

  function LoginAgain() {
    localStorage.clear();
    navigate("/login");
    setOverlapStatus(false);
  }

  return (
    <>
      <div
        className={
          overlapStatus ? `${styles.overlap}` : `${styles.overlapClose}`
        }
      >
        <div className={styles.overlapBox}>
          <div className={styles.overlapOk}>
            <p className={styles.overlapPara}>
              You Password Changed Successfully Now Loging Again
            </p>
            <Button handleClick={LoginAgain}>Ok</Button>
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.box}>
          <h3 className={styles.heading}>Reset Password Page</h3>
          <form onSubmit={submitHandler}>
            <div className={styles.passwordBox}>
              <input
                className={styles.input}
                type={`${seePasswordOne ? "text" : "password"}`}
                placeholder="Enter New Password"
                value={newPassword}
                onChange={newPasswordHandler}
              ></input>
              <div onClick={ClickHandlerOne}>
                {seePasswordOne ? <FaEye></FaEye> : <FaEyeSlash></FaEyeSlash>}
              </div>
            </div>
            <div className={styles.passwordBox}>
              <input
                className={styles.input}
                type={`${seePasswordTwo ? "text" : "password"}`}
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={confirmPasswordHandler}
              ></input>
              <div onClick={ClickHandlerTwo}>
                {seePasswordTwo ? <FaEye></FaEye> : <FaEyeSlash></FaEyeSlash>}
              </div>
            </div>
            <p style={{ color: "red", marginBottom: "10px" }}>
              {newPassword !== confirmPassword
                ? "Confirm Password is not same"
                : ""}
            </p>
            <Button
              disabled={
                newPassword.length <= 0 ||
                confirmPassword.length <= 0 ||
                newPassword !== confirmPassword
              }
            >
              Reset
            </Button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ResetPasswordPage;
